const AlertTip = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 3.2a5.6 5.6 0 0 0-3.26 10.15c.45.33.71.85.71 1.4v1.15h5.1v-1.15c0-.55.26-1.07.71-1.4A5.6 5.6 0 0 0 12 3.2Z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
        <path d="M10.2 18.7h3.6" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
        <path d="M12 8.8v4" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
)

export default AlertTip;
